import { createContext, useContext, useState } from 'react';

const CategoriesContext = createContext<{
  isShowingCategory: boolean;
  setShowingCategory: (isShowing: boolean) => void;
}>({
  isShowingCategory: false,
  setShowingCategory: () => {},
});

export const useCategories = () => {
  return useContext(CategoriesContext);
};

export const CategoriesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isShowingCategory, setShowingCategory] = useState(false);
  return (
    <CategoriesContext.Provider
      value={{
        isShowingCategory: isShowingCategory,
        setShowingCategory: setShowingCategory,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  );
};
